const X = () => {
  return (
    <div>
      <svg
        width="58.7"
        height="71.9"
        viewBox="0 0 58.7 71.9"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          id="svgGroup"
          stroke-linecap="round"
          fill-rule="evenodd"
          font-size="9pt"
          stroke="#000"
          stroke-width="0.25mm"
          fill="black"
          // style="stroke:#000;stroke-width:0.25mm;fill:black"
        >
          <path
            d="M 0 66 L 23.5 35.3 L 1 5.9 L 8.9 0 L 29.2 28.4 L 49.3 0.3 L 56.7 5.9 L 34.9 34.8 L 58.7 66 L 51 71.9 L 28.9 41.9 L 7.5 71.7 L 0 66 Z"
            vector-effect="non-scaling-stroke"
          />
        </g>
      </svg>
    </div>
  );
};
export default X;
